import { Button } from '@zep-us/zus';
import { FileDownloadColorIcon, RectanglePortraitStackFillIcon, SchoolFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
export interface MobileQuickActionsProps {
  /** 플래시카드 버튼 클릭 핸들러 */
  onFlashcard?: () => void;
  /** 워크시트 내보내기 핸들러 */
  onExportWorksheet: () => void;
  /** 학급 연결 핸들러 */
  onLinkToClassroom?: () => void;
  /** 추가 CSS 클래스 */
  className?: string;
}

/**
 * MobileQuickActions - 모바일 화면 인라인 퀵 액션 버튼 그룹
 *
 * @description
 * 모바일 화면에서 문제 카드 위에 노출되는 액션 버튼 그룹입니다.
 * 플래시카드와 워크시트 다운로드 버튼은 가로 full width 안에서
 * 1:1 비율로 분할되고, 학급 연결 버튼은 필요할 때 아래 한 줄에 표시됩니다.
 *
 * 데스크톱에서는 동일한 액션이 우측 컬럼 CTA 그룹에 통합되어 있으므로,
 * 본 컴포넌트는 부모에서 오른쪽 CTA 칸이 보이는 폭부터 숨겨야 합니다(퀴즈 상세는 `tablet-lg:hidden`).
 */
export const MobileQuickActions = ({
  onFlashcard,
  onExportWorksheet,
  onLinkToClassroom,
  className
}: MobileQuickActionsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex w-full flex-col gap-xs', className)} data-sentry-component="MobileQuickActions" data-sentry-source-file="MobileQuickActions.tsx">
      <div className="flex w-full flex-row gap-xs">
        {onFlashcard && <Button size="sm" variant="outlined" intent="neutral" onClick={onFlashcard} leftSlot={<RectanglePortraitStackFillIcon size="xs" className="text-blue-300" />} className="flex-1">
            {t('common:flashcard.label')}
          </Button>}
        <Button size="sm" variant="outlined" intent="neutral" onClick={onExportWorksheet} leftSlot={<FileDownloadColorIcon size="sm" />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileQuickActions.tsx">
          {t('common:quizWorksheet.shortLabel')}
        </Button>
      </div>
      {onLinkToClassroom && <Button size="sm" variant="outlined" intent="neutral" onClick={onLinkToClassroom} leftSlot={<SchoolFillIcon size="xs" className="text-purple-300" />} className="w-full">
          {t('common:classroom.linkToClassroom')}
        </Button>}
    </div>;
};